import { STONE_BED_POINTS_MOVED } from "../lib/types";

export const pointsMoved = points => dispatch => {
    dispatch({
        type: STONE_BED_POINTS_MOVED,
        payload: points,
    });
};



// WEBPACK FOOTER //
// ./src/actions/stone-bed-actions.js